var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Test Webchat Widget"}},[_c('v-container',[_c('m-test-widget',{attrs:{"organization_id":_vm.$route.params.organization_id}}),_c('h2',[_vm._v("Help")]),_c('m-settings-organization-help-widget',{attrs:{"inboxes":_vm.cur_inboxes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }